import { Select } from 'antd';
import { useMemo, type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import useColorScheme from '@/hooks/useColorScheme';

import type { ColorSchemePreference } from '@/theme/colorScheme';

const PREFERENCES: ColorSchemePreference[] = ['light', 'dark', 'system'];

const ColorSchemeSwitcher = () => {
  const [t] = useTranslation();
  const { preference, setPreference } = useColorScheme();

  const options = useMemo(
    () => [
      { value: 'light' as const, label: t('COLOR_SCHEME_LIGHT') },
      { value: 'dark' as const, label: t('COLOR_SCHEME_DARK') },
      { value: 'system' as const, label: t('COLOR_SCHEME_SYSTEM') },
    ],
    [t],
  );

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <Select
      value={preference}
      options={options}
      onSelect={(next) => {
        if (PREFERENCES.includes(next)) {
          setPreference(next);
        }
      }}
      onClick={handleClick}
      data-testid="color-scheme-switcher"
    />
  );
};

export default ColorSchemeSwitcher;
